import { Fragment, useState, useEffect, useRef } from 'react';
import { Outlet, Link } from 'react-router-dom';

const Navigation = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navRef = useRef(null);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsNavOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [navRef]);

  return (
    <Fragment>
      <nav className="relative md:sticky md:top-0 z-10 w-full bg-gray-800 shadow-lg" ref={navRef}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between">
            <div className="flex space-x-4">
              {/* Logo */}
              <div>
                <Link className="flex items-center py-5 px-2 text-gray-100" to='/'>
                  <span className="font-bold text-xl">AURRPC</span>
                </Link>
              </div>

              {/* Primary Nav - hidden on mobile */}
              <div className="hidden md:flex items-center space-x-1">
                <Link className="py-5 px-3 text-gray-400 hover:text-white" to='/diciplines'>Diciplines</Link>
                <Link className="py-5 px-3 text-gray-400 hover:text-white" to='/affiliations'>Affiliations</Link>
                <Link className="py-5 px-3 text-gray-400 hover:text-white" to='/collectors'>Collectors</Link>
                <Link className="py-5 px-3 text-gray-400 hover:text-white" to='/membership'>Membership</Link>
                <Link className="py-5 px-3 text-gray-400 hover:text-white" to='/calendar'>Calendar</Link>
                <span className="py-5 px-3 text-gray-400 hover:text-white">
                  <a href="./downloads/AURRPC_Merch_2026.pdf">Merchandise</a>
                </span>
                <Link className="py-5 px-3 text-gray-400 hover:text-white" to='/faq'>FAQ</Link>
                <Link className="py-5 px-3 text-gray-400 hover:text-white" to='/contact-us'>Contact Us</Link>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button
                className="mobile-menu-button p-2 rounded-md text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                onClick={toggleNav}
                aria-label="Toggle menu"
              >
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu - shown/hidden based on menu state */}
        <div className={`md:hidden ${isNavOpen ? 'block' : 'hidden'}`}>
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-gray-800 border-t border-gray-700">
            <Link className="block py-2 px-3 text-gray-400 hover:text-white" to='/diciplines'>Diciplines</Link>
            <Link className="block py-2 px-3 text-gray-400 hover:text-white" to='/affiliations'>Affiliations</Link>
            <Link className="block py-2 px-3 text-gray-400 hover:text-white" to='/collectors'>Collectors</Link>
            <Link className="block py-2 px-3 text-gray-400 hover:text-white" to='/membership'>Membership</Link>
            <Link className="block py-2 px-3 text-gray-400 hover:text-white" to='/calendar'>Calendar</Link>
            <span className="block py-2 px-3 text-gray-400 hover:text-white">
              <a href="./downloads/AURRPC_Merch.pdf">Merchandise</a>
            </span>
            <Link className="block py-2 px-3 text-gray-400 hover:text-white" to='/faq'>FAQ</Link>
            <Link className="block py-2 px-3 text-gray-400 hover:text-white" to='/contact-us'>Contact Us</Link>
          </div>
        </div>
      </nav>
      <Outlet />
    </Fragment>
  );
}

export default Navigation;

